// extracted by mini-css-extract-plugin
export default {"body":"ReportSection_body__RmiPr","p":"ReportSection_p__f-PS1","wide":"ReportSection_wide__pxprI"};